import { Redirect } from "react-router-dom"

import ErrorPage from "@/components/ErrorPage"
import page_index from "@/pages/index"
import page_login from "@/pages/login"
import page_main from "@/pages/main"

import home from "@/pages/main/home"
import dingzhiHome from "@/pages/main/dingzhiHome"
import product from "@/pages/main/product"
import nutrition_science from "@/pages/main/nutrition-science"
import lost_and_found from "@/pages/main/lost-and-found"

const routes = [
	{
		path: "/",
		component: page_index,
		routes: [
			{
				path: "/",
				exact: true,
				render: () => <Redirect to="/main/home" />,
			},
			{
				path: "/login",
				component: page_login,
			},

			{
				path: "/main",
				component: page_main,
				routes: [
					{
						path: "/main/home",
						component: home, 	
					},
					{
						path: "/main/dingzhi-home",
						component: dingzhiHome, 	
					},
					{
						path: "/main/product",
						component: product,
					},
					{
						path: "/main/nutrition-science",
						component: nutrition_science,
					},
					{
						path: "/main/lost-and-found",
						component: lost_and_found,
					},
				],
			},
			{
				path: "*",
				exact: true,
				component: ErrorPage,
			},
		]
	}
]

export default routes
